import { useState } from 'react';
import { Container, Row, Col, InputGroup, FormControl, Button, Navbar, Nav, Modal } from 'react-bootstrap';
import { Loader, useMain, useGenerals } from '../util/useGenerals';
import axios from 'axios';

import logoafdi from '../afdi.svg';
import logosbh from '../logo.svg';

export const NewsletterBlock = () => {
    const main = useMain();
    const general = useGenerals();
    const [ email,setEmail ] = useState(undefined);
    const [ sent, setSent ] = useState(false);
    const [ error,setError ] = useState(undefined);
    const [ loading , setLoading ] = useState(null);

    const submitForm = () => {
        if(!sent){
            let url = general.domainBackEnd+'/api/suscribe' ;
            axios.post(url,{ email : email })
            .then( e => {
                if(e.data.error !== undefined){
                    setError(e.data.error_msg);
                    setLoading(null);
                    return;
                } else {
                    setLoading(null);
                    setError('Your email account was succesfully suscribed.');
                }
                setSent(true);
            })
            .catch(
                err => {
                    setError('Error submiting this request. Try again.');
                    setLoading(null);
                }
                );
        } else {
            setError('The suscription is already sent.');
            setLoading(null);
        }
    }

    const validate = () =>{
        setLoading("newVall")
        let ifarr = email.includes('@');

        if(!ifarr) {
            setError('This is not an email.');
            setLoading(null); 

        }else{
            submitForm()
        }
    }

    return <Container id='theproject' className={'py-0'}>
        <Row className={'py-5 align-items-center justify-content-between'}>
            <Col xs={12} lg={5}>
                <h1 className={'lightsubtitle'}>Coming in 2023.</h1>
                <h1>IT'S TIME TO FIND YOUR NEW HOME</h1>
                <p className={'m-0'}>Are you interested? Suscribe to our newsletter and receive news and updates about this project.</p>
                {error ? <div className={'alert alert-warning alert-sm py-2 mt-5'}>{error}</div> : null }
                
                <InputGroup className="mt-5">
                    <FormControl
                        onChange={
                            (e)=>{
                                setEmail(e.target.value)
                                setError(undefined)
                            }
                        }
                        placeholder="Your email here"
                        aria-label="Your email here"
                        aria-describedby="your-email-here"
                    />
                    <Button 
                        onClick={()=>validate()}
                        disabled={!email || loading ? true : false}
                        variant="outline-secondary" 
                        id="button-addon2">
                        { loading === null ? 'Suscribe' : <Loader /> }
                    </Button>
                </InputGroup>

            </Col>
            <Col xs={12} lg={1}></Col>
            <Col>
                    <img className={'mt-5 mt-lg-0'} 
                    alt=''
                    src={ general.domainBackEnd + main.pictures[2].img } />
            </Col>
        </Row>
    </Container>
}


export const ContactForm = () => {
    const [ email,setEmail ] = useState("");
    const [ name,setName ] = useState("");
    const [ phone,setPhone ] = useState("");
    const [ message,setMessage ] = useState("");
    const [ sent, setSent ] = useState(false);
    const [ error,setError ] = useState(undefined);
    const [ loading , setLoading ] = useState(null);

    const general = useGenerals();

    const submitForm = () => {
        if(!sent){
            let url = general.domainBackEnd+'/api/contact' ;
            let body = {
                email : email,   
                name : name,
                phone : phone,
                message : message
            }
            axios.post(url,body)
            .then(e=>{
                setSent(true);
                setError('Message sent.');
                    
                setLoading(null);
            })
            .catch(
                err => {
                    setError('There was en error sending the message.');
                    setLoading(null);
                }
                );
        } else {
            setError('The message has been already sent.');
            setLoading(null);
        }
    }

    const validate = () =>{
        setLoading("1")

        let ifname = name.length > 3;
        let ifarr = email.length > 4 && email.includes('@');
        let ifphone = phone.length > 7 ;
        let ifmessage = message.length > 4 && message.length < 150;

        if(ifarr && ifname && ifphone && ifmessage) {
            submitForm(); 
            return;
        }

        setError('All fields listed in this form are required. Check the email, phone, and message field. If one of them has an unvalid format, this message wont be submitted.');
        setLoading(null)
    }

    return <div id={'contactus'} className={'bg-primary py-3'}>
        <Container className={'py-3 py-md-5'}>
            <Row className={'mb-5'}>
                <Col className={'text-center'}>
                    <h3 className={'text-white'}>Questions? Contact us! We are here to help!</h3>
                    {error ? <div className='py-2 mt-5 alert alert-warning'>{error}</div> : null }
                </Col>
            </Row>

            <Row>
                <Col xs={12} sm={12} md={6} lg={4}>
                    <FormControl
                        onChange={
                            (e)=>{
                                setName(e.target.value)
                                setError(undefined)
                            }
                        }
                        className={'mb-4'}
                        placeholder="Your name here"
                        aria-label="Your name here"
                        aria-describedby="your-name-here"
                    />

                    <FormControl
                        onChange={
                            (e)=>{
                                setEmail(e.target.value)
                                setError(undefined)
                            }
                        }
                        className={'mb-4'}
                        placeholder="Your email here"
                        aria-label="Your email here"
                        aria-describedby="your-email-here"
                    />    
                </Col>
                <Col xs={12} sm={12} md={6} lg={4}>
                <FormControl
                    onChange={
                        (e)=>{
                            setPhone(e.target.value)
                            setError(undefined)
                        }
                    }
                    className={'mb-4'}
                    placeholder="Your phone here"
                    aria-label="Your phone here"
                    aria-describedby="your-phone-here"
                />

                <FormControl
                    onChange={
                        (e)=>{
                            setMessage(e.target.value)
                            setError(undefined)
                        }
                    }
                    placeholder="Your message here"
                    aria-label="Your message here"
                    aria-describedby="your-message-here"
                />
                </Col>
                <Col xs={12} sm={12} md={6} lg={4}>
                    <Button 
                        className={'mt-4 mt-md-0'}
                        onClick={()=>validate()}
                        variant="outline-secondary">
                        {!loading ? 'SEND MESSAGE' : <Loader/>}
                    </Button>
                    
                </Col>
            </Row>

        </Container>
    </div>
}

export const Pictures = () => {
    const general = useGenerals();
    const main = useMain();

    const [show, setShow] = useState(false);
    const [content, setContent] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    let pictures = main.pictures.filter((item,index) => index !== 2)

    return <Container id={'pictures'} className={'pb-4'}>
        <Modal
            size="lg"
            centered
            show={show} onHide={handleClose}>
                <Modal.Body className={'p-0'}>
                    <img alt={ '' } src={ general.domainBackEnd + content } />
                </Modal.Body>
        </Modal>
        <Row className={'g-0 py-5'}>
            {pictures.map( function (item, index) {
                return <Col key={ 'pic'+index } xs={12} sm={6} md={4}>
                    <div
                        onClick={() => {
                            setContent(item.img)
                            setShow(true)
                        }}
                        className={'pictureContainer'}>
                        <div className={'bg-transparent-main'}></div>
                        <img alt='' src={ general.domainBackEnd + item.img } />
                    </div>
                    
                </Col>
            })}
        </Row>
    </Container>
}

export const Slogan = () => {
    return <Container>
        <div className={'bg-secondary my-3 p-5'}>
            <Row className={'text-center'}>
                <Col>
                    <h3 className={'m-0'}>High quality materials in a  contemporary / modern design.</h3>
                </Col>
            </Row>
        </div>
    </Container>
}

export const Layout = ( {children} ) => {
    const main = useMain();
    const general = useGenerals();

    return main ? 
        <div>
            <div className='py-4 bg-secondary'>
                <Container>
                    <Row>
                        <Col>
                            <div className={'d-flex g-0 g-md-0 py-md-0 align-items-center justify-content-between'}>
                                <a 
                                    className={'px-0 d-block'}
                                    href={main.about.link}>
                                        <img 
                                            height={50}
                                            src={logosbh}
                                            alt={'SBH - Summerbloom Homes'}
                                        />
                                </a>
                                <a 
                                    className={'px-0 d-block'}
                                    href={main.about.link}>
                                        <img 
                                            height={50}
                                            src={logoafdi}
                                            alt={'afdi construction inc'}
                                        />
                                    </a>
                                </div>
                            </Col>
                    </Row>
                </Container>
            </div>
            <header>
                <Container>
                    <Row className='py-3 g-0 g-md-2 py-md-4 py-lg-5 justify-content-between'>
                        <Col xs='9' sm='10' md='6' lg='4' xl='4'>
                            <a href='/'>
                                <img src={general.domainBackEnd+main.config.logo} alt={main.config.webName} />
                            </a>
                        </Col>
                        <Col xs='3' sm='2' lg='8' xl='8' >
                            <div className='px-0 d-flex justify-content-end'>
                                <Navbar expand="lg">
                                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                    <Navbar.Collapse id="basic-navbar-nav">
                                    <Nav className="me-auto">
                                        {
                                            main.menu.map( 
                                                (i, index) => 
                                                <Nav.Link 
                                                    key={'link'+index}
                                                    href={i.link}
                                                    className={'px-4'}
                                                    >
                                                        {i.name}
                                                </Nav.Link>
                                            )
                                        }
                                        
                                    </Nav>
                                    </Navbar.Collapse>
                                </Navbar>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </header>
            {children}
            <footer className='py-3 bg-secondary'>
                <Container>
                    <Row className={'p-0 p-md-5 justify-content-center'}>
                        <Col xs='12'>
                            <div className={'d-flex align-items-center justify-content-center'}>
                            <a 
                                className={'px-4 d-block'}
                                href={main.about.link}>
                                    <img 
                                        height={110}
                                        src={logosbh}
                                        alt={'SBH - Summerbloom Homes'}
                                    />
                                </a>
                                <a 
                                className={'px-4 d-block'}
                                href={main.about.link}>
                                    <img 
                                        height={110}
                                        src={logoafdi}
                                        alt={'afdi construction inc'}
                                    />
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
            </div>
        :
        <Loader />
    
}